module.exports = __webpack_public_path__ + "img/onboarding.6791d127.svg";